export default __webpack_public_path__ + "static/media/p-10.29ad4a43.png";